var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPriceDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7536 13.8377L10.7537 4.68817C10.7536 4.27396 10.4177 3.93825 10.0035 3.93835C9.58931 3.93846 9.25361 4.27432 9.25371 4.68854L9.25357 13.8377L4.87701 9.46117C4.58412 9.16827 4.10924 9.16827 3.81635 9.46117C3.52346 9.75406 3.52346 10.2289 3.81635 10.5218L9.47321 16.1787C9.76611 16.4716 10.241 16.4716 10.5339 16.1787L16.1837 10.5289C16.4766 10.236 16.4766 9.76112 16.1837 9.46823C15.8908 9.17533 15.4159 9.17533 15.123 9.46823L10.7536 13.8377Z",
    fill: "#ff4820"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceDown);
export default __webpack_public_path__ + "static/media/price-down.92d10595.svg";
export { ForwardRef as ReactComponent };